import useSWR, { SWRResponse } from 'swr';
import { PendingCustomer, PendingCustomersResponse } from './useGetPendingCustomers';

/**
 * Fetches a pending customer registration by id
 * @param id - Pending customer id
 */
const useGetPendingCustomerById = (
  id?: string
): SWRResponse<PendingCustomersResponse, Error> & {
  customer: PendingCustomer | undefined;
} => {
  const props = useSWR<PendingCustomersResponse, Error>(
    id ? `/partner/customer/pending?id=${id}` : null,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return {
    ...props,
    customer: props.data?.page?.[0],
  };
};

export default useGetPendingCustomerById;
